import { Container, Right } from 'zf-web-components';
import { useIFrameUrl } from './hooks';
import type { ReactElement } from 'react';

function Iframe(): ReactElement {
  const url = useIFrameUrl();

  // 使用内联样式对象
  const style = {
    width: '100%',
    height: 'calc(100vh - 58px)', // header是52px，这里有6px不知道来源
    border: 'none'
  };

  return (
    <Container>
      <Right>
        <iframe style={style} src={url} onLoad={() => console.log(url)} />
      </Right>
    </Container>
  );
}

export default Iframe;
